export default {
  setting: [],

  provinces: [],
  provinceCode: null,

  cities: [],
  cityCode: null,

  activityGroups: [],
  activityGroupCode: null,

  internalUnits: [],
  internalUnitCode: null,

  automationTypes: [],
  automationTypeCode: null,

  vehicles: [],
  vehicleCode: null,

  billboards: [],
  billboard: {},
  billboardCode: null,

  serviceTypes: [],
  serviceTypeCode: null,

  tariffs: [],
  tariff: {},
  tariffCode: null,

  waterBillPeriods: [],
  waterBillPeriodCode: null,
  waterBillPeriodCheck: [],

  notices: [],
  notice: {},
  noticeCode: null,

  subscribers: [],
  subscriber: {},

  transactionInfos: [],
};
